// removed by extract-text-webpack-plugin
module.exports = {"link":"Ntl35","message":"BSz1G","contacts":"_18G4H","send":"p3Bsw","templates":"_3IOmR","group":"_2c2_D","api":"l43Vd","root":"_2gcJx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navigation.css
// module id = 576
// module chunks = 0